import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { getHomePageData } from "redux/actions/pageActions";
import DashboardHeader from "./DashboardHeader";
import DashboardSection from "./DashboardSection";
import useSessionFilters from "./useSessionFilters";
import { DEFAULT_FILTERS, FILTER_STORAGE_KEY, buildHomeFilterRequest } from "./homeFilters";

const Charts = ({ preTransactionCounts, transactionCounts, isLoading }) => {
  const dispatch = useDispatch();
  const clientId = useSelector((state) => state.clients.selectedClientId);
  const [filters, setFilters] = useSessionFilters(FILTER_STORAGE_KEY, DEFAULT_FILTERS);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const skipNextFetch = useRef(true);

  // The backend endpoint always returns both dashboards' counts together, and both
  // sections now share one filter row, so every filter change refetches and refreshes
  // both sections together.
  useEffect(() => {
    if (skipNextFetch.current) {
      skipNextFetch.current = false;
      return;
    }
    if (!clientId) return;

    setIsRefreshing(true);
    dispatch(getHomePageData(buildHomeFilterRequest(clientId, filters))).finally(() => {
      setIsRefreshing(false);
    });
  }, [dispatch, clientId, filters]);

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", overflowX: "hidden", display: "flex", flexDirection: "column", gap: "24px" }}>
      <DashboardHeader value={filters} onChange={setFilters} />
      <DashboardSection
        title="Pre-transaction"
        transactionCounts={preTransactionCounts}
        isLoading={isLoading || isRefreshing}
        basePath="/pre-transaction"
        filterValues={filters}
      />
      <DashboardSection
        title="Transaction"
        transactionCounts={transactionCounts}
        isLoading={isLoading || isRefreshing}
        basePath="/transaction"
        filterValues={filters}
      />
    </Box>
  );
};

export default Charts;
